// hooks/useSafeNavigate.js
import { usePageContext } from "./usePageContext";
import { useEffect, useState } from "react";

export function useSafeNavigate() {
    const pageContext = usePageContext();
    const [navigate, setNavigate] = useState(() => (path) => {
        // Fallback для SSR/SSG
        if (typeof window !== "undefined") {
            window.location.href = path;
        }
    });

    useEffect(() => {
        // Динамически импортируем useNavigate только на клиенте
        if (typeof window !== "undefined") {
            import("react-router-dom").then(({ useNavigate }) => {
                const navigateFn = useNavigate();
                setNavigate(() => navigateFn);
            });
        }
    }, []);

    return navigate;
}
